<div class="alert-box">
    <div class="modal-header">
        <button
            type="button"
            class="close"
            aria-label="Close"
            [class.disabled]="imageUploading$ | async"
            (click)="onClose()"
        >
            <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">
            {{ "free_photos_from" | translate }}
            <a [href]="'https://unsplash.com/' + IMAGE_UTMS" target="_blank">Unsplash</a>
        </h4>
    </div>

    <div class="modal-body">
        <ng-container *ngIf="(imageUploading$ | async) === false">
            <sp-image-search
                [apiUrl]="apiUrl"
                [style.display]="!selectedImage ? 'block' : 'none'"
                (selectedImage)="selectImage($event)"
            ></sp-image-search>

            <sp-image-preview *ngIf="selectedImage" [image]="selectedImage"></sp-image-preview>
        </ng-container>
        <ng-container *ngIf="(imageUploading$ | async) === true">
            <div class="image-uploading-state">
                {{ "uploading" | translate }}...
                <div class="preloader preloader-puff-rounds preloader-lg"></div>
            </div>
        </ng-container>
    </div>

    <div class="modal-footer" *ngIf="selectedImage">
        <div class="btns" [class.disabled]="imageUploading$ | async">
            <button type="button" class="btn btn-default" (click)="selectImage(null)">
                {{ "cancel" | translate }}
            </button>
            <button type="button" class="btn btn-success" [class.disabled]="!selectedImage" (click)="confirmImage()">
                {{ "select" | translate }}
            </button>
        </div>
    </div>
</div>
